<script setup lang="ts">
import { computed, inject } from "vue";

// Components
import Button from "@/dsComponents/buttons/Button.vue";
import Dropdown from "@/dsComponents/Dropdown/Dropdown.vue";
import DropdownGenerator from "@/dsComponents/Dropdown/DropdownGenerator.vue";

// Data and type import

import { useWorkerStatusActions } from "@/composables/missions/worker-status-actions/useWorkerStatusActions";

import type { DropdownGeneratorAction } from "@/dsComponents/Dropdown/types";
import type { WorkerMissionStatus } from '@/types/mission';

interface WorkerStatusActionsProps {
    availableStatuses: WorkerMissionStatus[];
}

const props = defineProps<WorkerStatusActionsProps>();

const { workerStatusActions } = useWorkerStatusActions();

const actionLoading = inject("actionLoading") as boolean;

const actions = computed<DropdownGeneratorAction[]>(() => {
    return workerStatusActions(props.availableStatuses);
});
</script>

<template>
    <div class="worker-status-actions">
        <Dropdown width="200px" :closeOnDescendant="true">
            <template #trigger-zone>
                <Button class="button-dropdown" variant="ghost" type="neutral" size="xs" iconOnly="dots" :loading="actionLoading" />
            </template>
            <template #dropdown-content>
                <DropdownGenerator :actions="actions" />
            </template>
        </Dropdown>
    </div>
</template>
<style scoped lang="scss"></style>
